import { render, staticRenderFns } from "./TarificateurParent.vue?vue&type=template&id=5bbfe864&scoped=true&"
import script from "./TarificateurParent.vue?vue&type=script&lang=js&"
export * from "./TarificateurParent.vue?vue&type=script&lang=js&"
import style0 from "./TarificateurParent.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./TarificateurParent.vue?vue&type=style&index=1&id=5bbfe864&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bbfe864",
  null
  
)

export default component.exports